import { createSelector } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { IStoreState } from "../../../../reducers/types";
import { filterOutSpendAndGetOffers } from "halifax";

const getAllTravelWalletOffers = (state: IStoreState) =>
  state.flightTravelWallet.offers;

export const getTravelWalletOffers = createSelector(
  getAllTravelWalletOffers,
  (offers) => filterOutSpendAndGetOffers(offers)
);

export const getActiveTravelWalletOffers = createSelector(
  getTravelWalletOffers,
  (offers) => {
    return offers.filter((offer) => {
      return dayjs().isAfter(dayjs(offer?.saleEventStartOn));
    });
  }
);
export const getTravelWalletCredit = (state: IStoreState) =>
  state.flightTravelWallet.credit;

export const getCreditBreakdown = (state: IStoreState) =>
  state.flightTravelWallet.creditBreakdown;

export const getTravelCreditsHistoryTransaction = (state: IStoreState) =>
  state.flightTravelWallet.creditsHistoryTransactions;

export const getPartialHistoryValidFromTime = (state: IStoreState) =>
  state.flightTravelWallet.partialHistoryValidFromTime;
